import React, { Component } from "react";
import { Segment, Header, Icon, Input } from 'semantic-ui-react';

class MessagesHeader extends Component {
    render() { 
        const {channelName,numUniqueUsers,handleSearchChange,searchLoading,isPrivateChannel}=this.props;
        return (
            <Segment clearing>
                {/*Channel Title*/}
<Header fluid="true" as="h2" floated="left" style={{marginBotttom:0}} >
<span>
    {channelName}
    {isPrivateChannel&&<Icon name={"star outline"} color="black"/>}
</span>
        <Header.Subheader>{numUniqueUsers}</Header.Subheader>
</Header>
 {/*Channel Search Input*/}
<Header floated="right">
<Input
loading={searchLoading}
onChange={handleSearchChange}
size="mini"
icon="search"
name="searchTerm"
placeHolder="Search Messages"
/>
</Header>
            </Segment>
          );
    }
}
 
export default MessagesHeader;


// WEBPACK FOOTER //
// ./src/components/Messages/MessagesHeader.js